import {
  LinkPreview,
  MessagesResponse,
  convertLinkPreview,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { t } from 'app/i18l'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { DAYS_TO_MS, MINS_TO_MS } from 'shared/constants'
import { cleanUrl } from './shared/utils'

export function useLinkPreview(url?: string) {
  let cleanedUrl = ''
  try {
    cleanedUrl = cleanUrl(url)
  } catch (e) {
    console.warn(e)
  }
  const { server } = useServer()
  const key = keys.linkPreview(cleanedUrl)
  const query = useQuery<LinkPreview | undefined>({
    queryKey: key,
    queryFn: fetchLinkPreview,
    enabled: !!cleanedUrl,
    staleTime: 7 * DAYS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    retryDelay: 10 * MINS_TO_MS,
  })

  if (query.error) {
    const errorData: LinkPreview = {
      title: t('error'),
      description: t('linkPreviewError'),
    }
    return {
      ...query,
      data: errorData,
    }
  }
  if (
    query.data &&
    !Object.values(query.data).some(value => value !== undefined)
  ) {
    return { ...query, data: undefined }
  }
  return query

  async function fetchLinkPreview() {
    if (!cleanedUrl) {
      return {}
    }

    const formData = new FormData()
    formData.append('url', cleanedUrl)

    const response = await server.post<MessagesResponse.LinkPreview>(
      `/v2/chat/messages/link-preview`,
      formData,
      'user',
      'multipart/form-data'
    )
    return convertLinkPreview(response)
  }
}
